import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "../../../../custom.css";
import CustomTableFooter from "./Footer";
import useTable from "./useTable";
import useWindowDimensions from "../../../../customhooks/useWindowDimensions";
import CustomTableLines from "../TableLines";
import { Button, Dialog, LinearProgress } from "@mui/material";
import stylesCss, { Label } from "./style";
import { ContactContext } from "../../../../context/contact/ContactContext";
import FilterDeliveryDate from "../Filter/DeliveryDate";
import { Container, H3, OneColumn, SearchButton } from "../../style";

const CustomTable = ({ data, rowsPerPage }) => {
  const { t } = useTranslation();
  const classesSx = stylesCss;
  const { vendorInformation, getPurchLines, setPurchLines } =
    useContext(ContactContext);
  const { width } = useWindowDimensions();
  const [purchStatusLocal, setPurchStatusLocal] = useState(-1);
  const [averageServiceLevel, setAverageServiceLevel] = useState(0);
  const [messageCountry, setMessageCountry] = useState(true);
  const [viewpurchLine, setViewPurchLines] = useState(false);
  const [wait, setWait] = useState(false);
  const [purch, setPurch] = useState({});
  const [page, setPage] = useState(1);
  const [isfilter, setIsfilter] = useState(false);
  const [dataTemp, setDataTemp] = useState([]);
  const [maxDate, setMaxDate] = useState(
    new Date().toISOString().slice(0, 10).toString()
  );
  const [minDate, setMinDate] = useState(
    new Date().toISOString().slice(0, 10).toString()
  );

  if (data.length > 0 && dataTemp.length === 0 && isfilter === false) {
    setPurchStatusLocal(data[0].purchStatus);
    data.sort(function (a, b) {
      if (a.deliveryDate.substring(0, 10) > b.deliveryDate.substring(0, 10))
        return 1;
      if (a.deliveryDate.substring(0, 10) < b.deliveryDate.substring(0, 10))
        return -1;
      return 0;
    });
    setDataTemp(data);
    setMinDate(data.sort()[0].deliveryDate.substring(0, 10));
    setMaxDate(data.sort()[data.length - 1].deliveryDate.substring(0, 10));
  }
  const { slice, range } = useTable(dataTemp, page, rowsPerPage);
  const filter = (e) => {
    const keyword = e.target.value;
    if (keyword !== "") {
      setIsfilter(true);
      const results = data.filter((dataT) => {
        return dataT[e.target.name].includes(keyword.toLowerCase());
      });
      setDataTemp(results);
    } else {
      setIsfilter(false);
      setDataTemp(data);
    }
  };
  const filterDate = (fromDate, toDate) => {
    setIsfilter(true);
    const results = data.filter((dataT) => {
      if (vendorInformation.country === "ECU") {
        return (
          dataT.deliveryDate.substring(0, 10) >= fromDate &&
          dataT.deliveryDate.substring(0, 10) <= toDate
        );
      } else {
        return (
          dataT.deliveryDateExt.substring(0, 10) >= fromDate &&
          dataT.deliveryDateExt.substring(0, 10) <= toDate
        );
      }
    });
    setDataTemp(results);
  };
  const handlePurchLines = async (e, item) => {
    setWait(true);
    e.preventDefault();
    await getPurchLines(item.purchId);
    setPurch(item);
    setWait(false);
    setViewPurchLines(true);
  };
  const handleBack = () => {
    setDataTemp(data);
    setPurchLines({});
    setViewPurchLines(false);
  };
  const handleCloseCountry = () => {
    setMessageCountry(false);
  };
  useEffect(() => {
    let sum = 0;
    let i;
    for (i = 0; i < data.length; i++) {
      sum = sum + data[i].serviceLevel;
    }
    setAverageServiceLevel((sum / data.length).toFixed(2));
  }, []);
  useEffect(() => {
    let sum = 0;
    let i;
    for (i = 0; i < dataTemp.length; i++) {
      sum = sum + dataTemp[i].serviceLevel;
    }
    setAverageServiceLevel((sum / dataTemp.length).toFixed(2));
  }, [dataTemp]);

  return (
    <>
      {wait && <LinearProgress color="error" />}
      {vendorInformation.country === null ||
      vendorInformation.country === "" ? (
        <Dialog onClose={handleCloseCountry} open={messageCountry}>
          <br />
          <Container>
            <H3>{t("notificationCountry")}</H3>
          </Container>
          <Container>
            <OneColumn>
              <SearchButton onClick={handleCloseCountry}>
                {t("close")}
              </SearchButton>
            </OneColumn>
          </Container>
        </Dialog>
      ) : (
        !viewpurchLine &&
        !wait && (
          <>
            <br />
            <h1 className="cssTittle">{t("purchaseOrders")}</h1>
            <br />
            {purchStatusLocal > 1 && (
              <Label>
                {t("averageServiceLevel") + ": " + averageServiceLevel + "/100"}
              </Label>
            )}
            <CustomTableFooter
              range={range}
              slice={slice}
              setPage={setPage}
              page={page}
              side={1}
            />
            <Table className="table">
              <Thead className="tableRowHeader">
                <Tr>
                  <Th className="tableHeader">{t("purchaseOrder")}</Th>
                  <Th className="tableHeader">{t("subtotal")}</Th>
                  <Th className="tableHeader">{t("tax")}</Th>
                  <Th className="tableHeader">{t("total")}</Th>
                  <Th className="tableHeader">{t("state")}</Th>
                  {vendorInformation.country === "ECU" ? (
                    <Th className="tableHeader">{t("confirmationDate")}</Th>
                  ) : (
                    <Th className="tableHeader">{t("dispatchRequestDate")}</Th>
                  )}
                  {purchStatusLocal > 1 && (
                    <Th className="tableHeader">{t("serviceLevel")}</Th>
                  )}
                </Tr>
              </Thead>
              <Tbody>
                {width > 642 ? (
                  <Tr className="tableCell">
                    <Td>
                      <input
                        className="form-control"
                        type="text"
                        id="purchId"
                        name="purchId"
                        placeholder={t("filter")}
                        onChange={(e) => filter(e)}
                      />
                    </Td>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                    <Td>
                      <FilterDeliveryDate
                        minDate={minDate}
                        maxDate={maxDate}
                        filterDate={filterDate}
                      />
                    </Td>
                    {purchStatusLocal > 1 && <Td></Td>}
                  </Tr>
                ) : (
                  <Tr className="tableCell">
                    <Td>
                      <input
                        className="form-control"
                        type="text"
                        id="purchId"
                        name="purchId"
                        placeholder={t("filter")}
                        onChange={(e) => filter(e)}
                      />
                    </Td>
                  </Tr>
                )}
                {slice.length > 0 &&
                  slice.map((item, index) => (
                    <Tr
                      onClick={(e) => handlePurchLines(e, item)}
                      className="tableRowItems"
                      key={index}
                    >
                      <Td className="tableCell">{item.purchId}</Td>
                      <Td className="tableCell">{item.subTotalAmount}</Td>
                      <Td className="tableCell">{item.taxAmount}</Td>
                      <Td className="tableCell">{item.totalAmount}</Td>
                      {item.purchStatus === 1 && (
                        <Td className="tableCell">{t("openOrder")}</Td>
                      )}
                      {item.purchStatus === 2 && (
                        <Td className="tableCell">{t("orderReceived")}</Td>
                      )}
                      {item.purchStatus === 3 && (
                        <Td className="tableCell">{t("closedOrder")}</Td>
                      )}
                      {vendorInformation.country === "ECU" ? (
                        <Td className="tableCell">
                          {item.deliveryDate.substring(0, 10)}
                        </Td>
                      ) : (
                        <Td className="tableCell">
                          {item.deliveryDateExt.substring(0, 10)}
                        </Td>
                      )}
                      {purchStatusLocal > 1 && (
                        <Td className="tableCell">{item.serviceLevel}</Td>
                      )}
                    </Tr>
                  ))}
              </Tbody>
            </Table>
            <CustomTableFooter
              range={range}
              slice={slice}
              setPage={setPage}
              page={page}
              side={2}
            />
          </>
        )
      )}
      {viewpurchLine && (
        <>
          <CustomTableLines data={purch} rowsPerPage={1000} />
          <br />
          <br />
          <Button
            sx={{ ...classesSx.btnRegresar }}
            variant="contained"
            onClick={handleBack}
          >
            {t("back")}
          </Button>
        </>
      )}
    </>
  );
};

export default CustomTable;
